import { useEffect, useState, useRef } from "react";

const useVisibility = () => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentRef = ref.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        const currentlyVisible = entry.isIntersecting;

        // Only update if visibility has changed
        setIsVisible(prev => (prev !== currentlyVisible ? currentlyVisible : prev));
      },
      {
        // Change threshold to update visible window area
        threshold: 0.45,
      }
    );

    observer.observe(currentRef);

    return () => {
      observer.unobserve(currentRef);
    };
  }, [ref.current]);

  return { ref, isVisible };
};

export default useVisibility;
